export const NOTE_RADIUS = 12;
export function createFretboardConfig(canvas) {
    const padding = 40;
    const numStrings = 4;
    const numFrets = 5;
    const stringSpacing = (canvas.width - 2 * padding) / (numStrings - 1);
    const fretSpacing = (canvas.height - 2 * padding) / numFrets;
    return {
        padding,
        numStrings,
        numFrets,
        stringSpacing,
        fretSpacing,
    };
}
export function drawFrets(ctx, canvas, config) {
    ctx.strokeStyle = '#666';
    ctx.lineWidth = 2;
    for (let i = 0; i <= config.numFrets; i++) {
        const y = config.padding + i * config.fretSpacing;
        ctx.beginPath();
        ctx.moveTo(config.padding, y);
        ctx.lineTo(canvas.width - config.padding, y);
        ctx.stroke();
    }
}
export function drawNut(ctx, canvas, config) {
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(config.padding, config.padding);
    ctx.lineTo(canvas.width - config.padding, config.padding);
    ctx.stroke();
}
export function drawStrings(ctx, canvas, config) {
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 1;
    for (let i = 0; i < config.numStrings; i++) {
        const x = config.padding + i * config.stringSpacing;
        ctx.beginPath();
        ctx.moveTo(x, config.padding);
        ctx.lineTo(x, canvas.height - config.padding);
        ctx.stroke();
    }
}
export function drawFretboard(ctx, canvas, note, answer) {
    const config = createFretboardConfig(canvas);
    // Wipe the whole canvas before redrawing the frame
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawFrets(ctx, canvas, config);
    drawNut(ctx, canvas, config);
    drawStrings(ctx, canvas, config);
    // Highlight current note
    const stringIndex = config.numStrings - note.string;
    const fretIndex = note.fret;
    let x = config.padding + stringIndex * config.stringSpacing;
    let y;
    if (fretIndex === 0) {
        y = config.padding - 15;
    }
    else {
        y = config.padding + fretIndex * config.fretSpacing - config.fretSpacing / 2;
    }
    // Draw circle at position
    ctx.fillStyle = '#FF6B6B';
    ctx.beginPath();
    ctx.arc(x, y, NOTE_RADIUS, 0, 2 * Math.PI);
    ctx.fill();
    // Display note name
    if (answer) {
        ctx.fillStyle = '#FFF';
        ctx.font = 'bold 16px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(note.note, x, y + 5);
    }
}
